<template>
  <div style="position: relative;">
    <CHeader fixed with-subheader light id="bigcontainer">
      <div class="nav-section">
        <router-link to="/">
          <img
            src="@/assets/logo_no_r.svg"
            class="d-inline-block align-top"
            alt="NeuroLeap Corp"
          />
        </router-link>
      </div>

      <div v-if="!userLeveL" id="navMiddle-container" class="nav-section d-md-down-none">
        <router-link to="/" exact-active-class="active-link">
          Home
        </router-link>
        <router-link to="/aboutUs" exact-active-class="active-link">
          About Us
        </router-link>
        <router-link to="/reportsStatistics" exact-active-class="active-link">
          Reports/Statistics
        </router-link>
        <router-link to="/rolesPage" exact-active-class="active-link">
          Roles
        </router-link>
        <router-link to="/rolesPage/searchAppAdminApps/viewAppAdminApps" exact-active-class="active-link">
          App Admin
        </router-link>
        <router-link to="/rolesPage/viewAllApplications" exact-active-class="active-link">
          Marketplace
        </router-link>
        <router-link v-if="isSuperAdmin" to="/userManagePage" exact-active-class="active-link">
          Manage User
        </router-link>
      </div>
      
      <div v-else-if="userLeveL == 'App Admin'" id="navMiddle-container" class="nav-section d-md-down-none">
        <router-link to="/" exact-active-class="active-link">
          Dashboard
        </router-link>
        <router-link to="/rolesPage/searchAppAdminApps/viewAppAdminApps" exact-active-class="active-link">
          My Apps
        </router-link>
        <router-link to="/pageNotAvailable" exact-active-class="active-link">
          Sales and Promotions
        </router-link>
        <router-link to="/rolesPage/viewAllApplications" exact-active-class="active-link">
          Marketplace
        </router-link>
      </div>
      <div v-else-if="userLeveL == 'Developer'" id="navMiddle-container" class="nav-section d-md-down-none">
        <router-link to="/" exact-active-class="active-link">
          Home
        </router-link>
        <router-link to="/dataPipelineTool" exact-active-class="active-link">
          Data Pipeline Tool
        </router-link>
      </div>
      <div v-else-if="userLeveL == 'Parent/Caretaker'" id="navMiddle-container" class="nav-section d-md-down-none">
        <router-link to="/SpecialistDashboard/insights" exact-active-class="active-link">
          Dashboard
        </router-link>
        <router-link to="/SpecialistInterventionPlan" exact-active-class="active-link">
          Progress
        </router-link>
        <router-link to="/rolesPage/viewAllApplications" exact-active-class="active-link">
          Marketplace
        </router-link>
      </div>
      <div v-else-if="userLeveL == 'Organization'" id="navMiddle-container" class="nav-section d-md-down-none">
        <router-link to="/organizationDashboard/insights" exact-active-class="active-link">
          Dashboard
        </router-link>
        <router-link to="/schools" exact-active-class="active-link">
          Sites
        </router-link>
        <router-link to="/organizationSpecialists" exact-active-class="active-link">
          Specialists
        </router-link>
        <router-link to="/activities" exact-active-class="active-link">
          Activities/Apps
        </router-link>
        <router-link to="/rolesPage/viewAllApplications" exact-active-class="active-link">
          Marketplace
        </router-link>
      </div>
      <div v-else id="navMiddle-container" class="nav-section d-md-down-none">
        <router-link to="/SpecialistDashboard/insights" exact-active-class="active-link">
          Dashboard
        </router-link>
        <router-link to="/SpecialistPatientsStudents" exact-active-class="active-link" :class="{ 'active-link': isPatientsTab }">
          Patients/Students
        </router-link>
        <div class="goals-dropdown">
          <button @click="toggleGoalsDropdown" class="goals-dropdown-button">
            Goals ▾
          </button>

          <div 
            class="goals-dropdown-menu"
            v-show="isGoalsDropdownOpen"
          >
            <a @click="routing('/SpecialistGoals/Screening')">Screening</a>
            <a @click="routing('/SpecialistGoals/Assessment')">Assessment</a>
            <a @click="routing('/SpecialistGoals/Intervention')">Intervention</a>
          </div>
        </div>
        <router-link to="/SpecialistInterventionPlan" exact-active-class="active-link" :class="{ 'active-link': isInterventionTab }">
          Intervention Plan
        </router-link>
        <router-link to="/activities" exact-active-class="active-link">
          Activities/Apps
        </router-link>
        <router-link to="/rolesPage/viewAllApplications" exact-active-class="active-link">
          Marketplace
        </router-link>
      </div>
      
      <div style="padding: 0;" class="nav-section d-md-down-none">
        <button v-if="!getEmail()" @click="routing('/login')" class="primary-button-sm-global login-signup-buttons navbar-button">
          Login
        </button>
        <button v-if="!getEmail()" @click="routing('/register')" class="secondary-color-button-sm-global login-signup-buttons navbar-button">
          Sign up
        </button>
        <div v-if="getEmail()" style="position: relative;">
          <button id="account-button" class="primary-button-sm-global" @click="toggleAccountDropdown('account-button-dropdown')">
            <div>
              {{ getEmail()}}
            </div>
          </button>
          <div v-if="userLeveL == 'Organization'" id="account-button-dropdown" class="account-dropdown">
            <div>
              <button class="secondary-color-button-sm-global" @click="routing('/OrganizationManagement')">Management</button>
              <button class="secondary-color-button-sm-global" @click="routing('/Calendar')">Calendar</button>
              <button class="secondary-color-button-sm-global" @click="logout">Logout</button>
            </div>
          </div>
          <div v-else id="account-button-dropdown" class="account-dropdown">
            <div>
              <button class="secondary-color-button-sm-global" @click="routing('/dashboard')">Dashboard</button>
              <button class="secondary-color-button-sm-global" @click="routing('/activities')">Activities</button>
              <button class="secondary-color-button-sm-global" @click="routing('/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard')">New Application</button>
              <hr v-if="isSuperuser">
              <button class="secondary-color-button-sm-global" v-if="isSuperuser" @click="routing('/updateUserLevel')">Manage Users</button>
              <hr>
              <button class="secondary-color-button-sm-global" @click="logout">Logout</button>
            </div>
          </div>
        </div>
      </div>
    </CHeader>
  </div>
</template>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #bigcontainer {
    $nav-padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100dvw;
    height: globalSharedVariables.$navbar-height;
    margin: 0;
    font-weight: 700;
    font-size: 1rem;
    padding: $nav-padding;
    background-color: rgba(255, 255, 255, 1);

    svg {
      height: calc(#{globalSharedVariables.$navbar-height} - 2 * #{$nav-padding} - 20px);
    }

    img {
      height: calc(#{globalSharedVariables.$navbar-height} - 2 * #{$nav-padding});
    }
    
    .nav-section {
      display: flex;
      justify-content: center;
      align-items: center;

      a {
        text-decoration: none;
        display: block;
        padding: 5px 10px;
        color: globalSharedVariables.$grey-900;
      }

      .active-link {
        color: globalSharedVariables.$brand-600;
        background-color: globalSharedVariables.$brand-100;
        border-radius: 5px;
      }
    }

    #searchApp-container {
      box-shadow: 0 0 5px 0 lightgrey;
      border-radius: 50rem;
      border: solid 1px globalSharedVariables.$brand-400;
      padding: 5px 10px;
      background-color: white;

      input {
        border: none;
        box-shadow: none;
        width: 75%;
      }

      #searchApp {
        font-size: 1rem;

        &:focus {
          border: 0;
          outline: 0;
        }

        &::placeholder {
          text-align: center;
        }
      }
    }

    .login-signup-buttons {
      white-space: nowrap;
      margin: 0 5px;
      width: 6rem;
    }

    .account-dropdown {
      display: none;
      position: fixed;
      top: globalSharedVariables.$navbar-height;
      right: 1.1rem;
      background-color: #FFFFFF;
      border: solid 1px #DFDFDF;
      padding: .75rem;
      border-radius: .5rem;

      hr {
        border-top: 1px solid #D8DBE0;
        border-radius: 50rem;
        opacity: 1;
        margin: 5px 0;
      }
    }

    #navMiddle-container {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      > button {
        margin: 0 5px;
      }
    }

    #account-button-dropdown {
      button {
        display: block;
        margin: 5px 0;
      }
    }
  }

  .goals-dropdown {
  position: relative;
  display: inline-block;

  .goals-dropdown-button {
    background: none;
    border: none;
    font-weight: 600;
    cursor: pointer;
    padding: 0.5rem 1rem;
  }

  .goals-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 0.5rem;
    margin-top: 0.3rem;
    min-width: 180px;
    z-index: 1000;
    flex-direction: column;

    a {
      color: black;
      padding: 0.5rem 0.8rem;
      text-decoration: none;
      display: block;

      &:hover {
        background-color: rgba(0, 128, 0, 0.1);
      }
    }
  }
}
</style>

<script>
import instance from "../axios.js";

export default {
  name: "NavigationBar",
  data() {
    return {
      searchTerm: "",
      isGoalsDropdownOpen: false,
      userName: "",
    };
  },
  methods: {
    toggleGoalsDropdown() {
      this.isGoalsDropdownOpen = !this.isGoalsDropdownOpen;
    },
    routing(url) {
      this.$router.push(url);
      this.isGoalsDropdownOpen = false; // hide after navigation
    },
    getEmail() {
      var email = this.$store.getters.getCurrentEmail;
      return email || null;
    },
    // getName(){
    //   var name = this.$store.getters.getUserFullName
    //   return name || null;
    // },
    async logout() {
      try {
        await instance.post(`api/auth/logout`, {});
        this.$store.commit("setUserLevel", null);
        this.$store.commit("setAuthUser", null);
        this.$store.commit("setCurrentEmail", null);
        this.$router.push("/");
      } catch (e) {
        console.error(e);
      }
    },
    toggleAccountDropdown(id) {
      let ref = document.getElementById(id);
      ref.style.display = ref.style.display === 'block' ? 'none' : 'block';
    },
    handleOutsideNavDropDownClick(e) {
      const dropdown = this.$el.querySelector('.goals-dropdown');
      if (dropdown && !dropdown.contains(e.target)) {
        this.isGoalsDropdownOpen = false;
      }
    },
    async getName() {
      try {
        const baseUrl =
          process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

        // first get auth cookie to find ID
        const authResp = await fetch(`${baseUrl}/api/auth/get-access-cookie-data`, {
          credentials: "include",
        });
        if (!authResp.ok) throw new Error("Failed to fetch auth data");

        const authData = await authResp.json();
        const userID = authData.id;

        // now call the /api/user/:id endpoint
        const userResp = await fetch(`${baseUrl}/api/user/${userID}`, {
          credentials: "include",
        });
        if (!userResp.ok) throw new Error("Failed to fetch user");

        const user = await userResp.json();

        // format name
        if (user.name) {
          const parts = user.name.split(" ");
          const formatted =
            parts.length > 2
              ? `${parts[0]} ${parts[1][0]}. ${parts[2]}`
              : parts.length > 1
              ? `${parts[0]} ${parts[1][0]}.`
              : parts[0];
          return formatted;
        } else {
          return "Unknown";
        }
      } catch (err) {
        console.error("Error fetching name:", err);
        return "Unknown";
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideNavDropDownClick);
    this.getName().then(name => {
      this.userName = name;
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideNavDropDownClick);
  },
  computed: {
    isPatientsTab() {
      const path = this.$route.path.toLowerCase();
      return path.startsWith('/specialistpatientsstudents') ||
             path.startsWith('/specialiststatisticsall') ||
             path.startsWith('/specialistgoals/screening/');
    },
    isInterventionTab() {
      const path = this.$route.path.toLowerCase();
      return path.startsWith('/specialistinterventionplan') ||
             path.startsWith('/specialiststatisticsindividual');
    },
    displayWebsite() {
      return this.$store.getters.isLoggedIn;
    },
    userLeveL() {
      return this.$store.getters.getUserLevel;
    },
    isSuperuser() {
      return this.$store.getters.getUserLevel === 'Super Admin';
    },
    isSuperAdmin() {
      const role = this.$store.getters.getUserLevel;
      return role === "Super Admin" || role === "Developer";
    },
  },
};
</script>